import * as React from 'react';
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ISkyddadYrkestitelPublicFormProps, SkyddadYrkestitelPublicForm } from './SkyddadYrkestitelPublicForm';

const WrappedForm = withGoogleReCaptcha(SkyddadYrkestitelPublicForm);
const scriptProps = { nonce: 'NONCE' };

export function SkyddadYrkestitelWrapper(props: ISkyddadYrkestitelPublicFormProps) {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={props.clientKey} scriptProps={scriptProps}>
      <WrappedForm {...props} />
    </GoogleReCaptchaProvider>
  );
}
